const LOADER_STATE = {
  init: 0,
  show: 1,
}

export default {
  namespaced: true,
  state: () => ({
    loading: false,
    requestsPending: 0,
  }),
  mutations: {
    show(state) {
      state.loading = true
    },
    hide(state) {
      state.loading = false
    },
    pending(state) {
      if (state.requestsPending === LOADER_STATE.init) {
        this.commit('LoaderStore/show')
      }

      state.requestsPending++
    },
    done(state) {
      if (state.requestsPending >= LOADER_STATE.show) {
        state.requestsPending--
      }

      if (state.requestsPending <= LOADER_STATE.init) {
        this.commit('LoaderStore/hide')
      }
    },
    init(state) {
      state.requestsPending = 0
      this.commit('LoaderStore/hide')
    },
  },
  actions: {
    show({ commit }) {
      commit('show')
    },
    hide({ commit }) {
      commit('hide')
    },
    pending({ commit }) {
      commit('pending')
    },
    done({ commit }) {
      commit('done')
    },
    init({ commit }) {
      commit('init')
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
  },
}
